import type * as React from "react"

const PROPOSAL_STATUSES = {
  DRAFT: "draft",
  PENDING_TO_REVIEW: "pending_review",
  APPROVED: "approved",
  DECLINED: "declined",
  CANCELLED: "cancelled",
  SENT_TO_CLIENT: "sent",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  EXPIRED: "expired"
} as const

type ProposalStatusesKeys = keyof typeof PROPOSAL_STATUSES
type ProposalStatuses = (typeof PROPOSAL_STATUSES)[ProposalStatusesKeys]

const PROPOSAL_STATUSES_OBJ: Record<
  string,
  {
    id: ProposalStatuses
    value: ProposalStatuses
    label: string
    style: React.CSSProperties
  }
> = {
  [PROPOSAL_STATUSES.DRAFT]: {
    id: PROPOSAL_STATUSES.DRAFT,
    value: PROPOSAL_STATUSES.DRAFT,
    label: "Draft",
    style: {
      color: "#616d73",
      backgroundColor: "#ECEFF1",
      borderColor: "#ECEFF1"
    }
  },
  [PROPOSAL_STATUSES.PENDING_TO_REVIEW]: {
    id: PROPOSAL_STATUSES.PENDING_TO_REVIEW,
    value: PROPOSAL_STATUSES.PENDING_TO_REVIEW,
    label: "In Review",
    style: {
      color: "#6e21f3",
      backgroundColor: "#efe3fd",
      borderColor: "#efe3fd"
    }
  },
  [PROPOSAL_STATUSES.APPROVED]: {
    id: PROPOSAL_STATUSES.APPROVED,
    value: PROPOSAL_STATUSES.APPROVED,
    label: "Approved",
    style: {
      color: "#4CAF50",
      backgroundColor: "#E8F5E9",
      borderColor: "#E8F5E9"
    }
  },
  [PROPOSAL_STATUSES.DECLINED]: {
    id: PROPOSAL_STATUSES.DECLINED,
    value: PROPOSAL_STATUSES.DECLINED,
    label: "Under Revision",
    style: {
      color: "#FF9800",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [PROPOSAL_STATUSES.CANCELLED]: {
    id: PROPOSAL_STATUSES.CANCELLED,
    value: PROPOSAL_STATUSES.CANCELLED,
    label: "Cancelled",
    style: {
      color: "#E53935",
      backgroundColor: "#FFEBEE",
      borderColor: "#FFEBEE"
    }
  },
  [PROPOSAL_STATUSES.SENT_TO_CLIENT]: {
    id: PROPOSAL_STATUSES.SENT_TO_CLIENT,
    value: PROPOSAL_STATUSES.SENT_TO_CLIENT,
    label: "Sent to Client",
    style: {
      color: "#0097A7",
      backgroundColor: "#E0F7FA",
      borderColor: "#E0F7FA"
    }
  },
  [PROPOSAL_STATUSES.ACCEPTED]: {
    id: PROPOSAL_STATUSES.ACCEPTED,
    value: PROPOSAL_STATUSES.ACCEPTED,
    label: "Accepted",
    style: {
      color: "#2E7D32",
      backgroundColor: "#C8E6C9",
      borderColor: "#C8E6C9"
    }
  },
  [PROPOSAL_STATUSES.REJECTED]: {
    id: PROPOSAL_STATUSES.REJECTED,
    value: PROPOSAL_STATUSES.REJECTED,
    label: "Rejected",
    style: {
      color: "#C62828",
      backgroundColor: "#FFCDD2",
      borderColor: "#FFCDD2"
    }
  },
  [PROPOSAL_STATUSES.EXPIRED]: {
    id: PROPOSAL_STATUSES.EXPIRED,
    value: PROPOSAL_STATUSES.EXPIRED,
    label: "Expired",
    style: {
      color: "#757575",
      backgroundColor: "#F5F5F5",
      borderColor: "#F5F5F5"
    }
  }
}

const PROPOSAL_STATUSES_MAP = Object.fromEntries(
  Object.values(PROPOSAL_STATUSES_OBJ).map((item) => [item.label, item])
) as Record<
  string,
  (typeof PROPOSAL_STATUSES_OBJ)[keyof typeof PROPOSAL_STATUSES_OBJ]
>

const PROPOSAL_SHARE_EMAIL_STATUSES = [
  PROPOSAL_STATUSES.APPROVED,
  PROPOSAL_STATUSES.SENT_TO_CLIENT
] as ProposalStatuses[]

export {
  PROPOSAL_STATUSES,
  PROPOSAL_SHARE_EMAIL_STATUSES,
  PROPOSAL_STATUSES_OBJ,
  PROPOSAL_STATUSES_MAP,
  type ProposalStatuses
}
